<template>
    <v-layout column align-center>
        <h2>Contributor Setup</h2>
        <br />

        <v-card>
        <v-card-title>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>
        <v-data-table
          :headers="headers"
          :items="contributors"
          class="elevation-1"
          :loading="tableLoading"
          :search="search"
        >
          <template
            slot="items"
            slot-scope="props"
          >
            <tr>
              <td class="body-2 text-xs-left">{{ props.item.uid }}</td>
              <td class="body-2 text-xs-left">{{ props.item.name }}</td>
              <td class="body-2 text-xs-left">{{ props.item.email }}</td>
              <td class="body-2 text-xs-left">{{ props.item.group }}</td>
              <td class="text-xs-right">
                        <v-icon
                          small
                          @click.stop="deleteContributor(props.item)"
                        >
                          delete
                        </v-icon>
                      </td>
            </tr>
          </template>
        </v-data-table>
        </v-card>
        <hr />
        <br />
        <v-layout row>
            <v-flex xs4>
                <v-subheader>Existing User Lookup</v-subheader>
            </v-flex>
            <v-flex xs8 >
              <v-text-field class="xs8"
                   label="Email"
                   placeholder="Put email here"
                   v-model="emailToLookup"
               ></v-text-field>
             </v-flex>
             <v-flex xs4 >
                 <v-btn @click="findUser" :loading="findingUser">Find User</v-btn>
             </v-flex>
        </v-layout>

        <div v-if="foundUser != null">
            UserID: {{ foundUser.uid }}<br />
            Name: {{ foundUser.displayName }}<br />
            Email: {{ foundUser.email }}<br />
            Last SignIn: {{ foundUser.metadata.lastSignInTime }}<br />
            Created: {{ foundUser.metadata.creationTime }}<br />
            <v-layout row>
                <v-text-field
                   label="Group"
                   placeholder="Group to add to"
                   v-model="newGroup"
                 ></v-text-field>
                 <v-btn @click="addToGroup">Add to Group</v-btn>
            </v-layout>
        </div>

        <br />
        <v-layout row>
            <v-flex xs4>
                <v-subheader>Create user record</v-subheader>
            </v-flex>
            <v-flex xs8 >
              <v-text-field class="xs8"
                   label="Name"
                   placeholder="Put name here"
                   v-model="nameToAdd"
               ></v-text-field>
               <v-text-field class="xs8"
                    label="Email"
                    placeholder="Put email here"
                    v-model="emailToAdd"
                ></v-text-field>
                 <v-text-field
                     prepend-icon="phone"
                     class="pa-1"
                     v-model="phoneToAdd"
                     :rules="validPhone"
                     label="Phone"
                     required
                     mask=phone
                  ></v-text-field>

             </v-flex>
             <v-flex xs4 >
                 <v-btn @click="createNewUser" :loading="userCreating">Create New User</v-btn>
             </v-flex>
        </v-layout>


        <h2>{{ statusMsg }}</h2>

    </v-layout>

</template>

<script>
  import utils from '@/utils.js'
  import firebase from 'firebase/app'
  // import functions from 'firebase/functions'

  export default {
      data () {
        return {
            search: '',
            tableLoading: false,
            emailSearching: false,
            userCreating: false,
            findingUser: false,


            nameToAdd: null,
            phoneToAdd: null,
            emailToAdd: null,
            newGroup: null,
            statusMsg: null,
            foundUser: null,
            emailToLookup: null,
            contributors: [],
            headers: [
              // {text: 'Category', value: 'category', align: 'left'},
              {text: 'UID', value: 'uid', align: 'left'},
              {text: 'Name', value: 'name', align: 'left'},
              {text: 'Email', value: 'email', align: 'left'},
              {text: 'Group', value: 'group', align: 'left'},
              {text: 'Actions', value: '', align: 'right'}
            ],
          validPhone: [
              utils.phoneValidation("Phone number must be 10 digits")
          ],
        }
      },
      mounted: function () {
          this.getContributors()
      },
      computed: {

      },
      methods: {
          getContributors: async function () {

              this.tableLoading = true;

              this.contributors = [];

              var getContrib = firebase.functions().httpsCallable('getContributors');
              getContrib({}).then((result) => {
                // Read result of the Cloud Function.
                var returnedInfo = result.data;
                // console.log("getContrib found:"+JSON.stringify(returnedInfo));

                // Set the user info.
                if (returnedInfo == null) {
                    this.statusMsg = "No contributors found.";
                } else {
                    // Iterate over array
                    for (let i=0; i<returnedInfo.length; i++) {
                        let rec = returnedInfo[i];
                        this.contributors.push(rec);
                    }

                    this.statusMsg = null;
                }

              }).catch((err) => {
                console.error("Error finding contributors:"+err);
                this.statusMsg = err;
              });

              this.tableLoading = false;

          },
          findUser: function () {
            // Try to find the user given their email.
            console.log("Finding "+this.emailToLookup);
            this.findingUser = true;
            this.statusMsg = null;
            this.foundUser = null;
            var findUser = firebase.functions().httpsCallable('findUser');
            findUser({emailToLookup: this.emailToLookup}).then((result) => {
              // Read result of the Cloud Function.
              var returnedInfo = result.data;
              // console.log("findUser found:"+JSON.stringify(returnedInfo));

              // Set the user info.
              if (returnedInfo == null) {
                  this.statusMsg = "Could not find user.";
              } else {
                  this.foundUser = returnedInfo.userRecord;
              }
              this.findingUser = false;
            }).catch((err) => {
              console.error("Error finding user:"+err);
              this.statusMsg = err;
              this.findingUser = false;
            });


          },
          addToGroup: async function() {
              // Save the new code
              let contriRef = firebase.database().ref('contributors').child(this.foundUser.uid);
              await contriRef.set(this.newGroup);
              this.getContributors();
          },
          deleteContributor:async function (contri) {
              // Delete
              let contributorRef = firebase.database().ref('contributors').child(contri.uid);
              await contributorRef.remove();

              // Reload
              this.getContributors();
          },
          createNewUser: async function () {
              // Try to create a new user with the given email.
              console.log("Creating  "+this.emailToAdd);
              this.userCreating = true;
              this.statusMsg = null;
              this.foundUser = null;
              var createUser = firebase.functions().httpsCallable('createUser');
              createUser({
                  email: this.emailToAdd,
                  phone: "+1"+this.phoneToAdd,
                  name: this.nameToAdd
              }).then((result) => {
                // Read result of the Cloud Function.
                var returnedInfo = result.data;
                // console.log("findUser found:"+JSON.stringify(returnedInfo));

                // Set the user info.
                if (returnedInfo == null) {
                    this.statusMsg = "Could not create user.";
                } else {
                    this.foundUser = returnedInfo.userRecord;
                    this.statusMsg = "User created.";
                }

              }).catch((err) => {
                console.error("Error finding user:"+err);
                this.statusMsg = err;
              });
              this.userCreating = false;
          }
      }

  }
</script>

<style>

</style>
